<template>
<v-container fill-height>
    <v-layout row wrap align-center justify-center>
        <v-flex xs12 sm10 md8 lg6 xl4>

            <form @submit.prevent="sendResetEmail" v-if="!results.active">
                <v-card class="elevation-10">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Reset Password</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4 class="subheading py-3">Enter the email address associated with your account and reset instructions will be sent to your inbox.</h4>

                        <!-- <div v-if="laravelErrors.active" class="text-xs-center">

<v-chip label color="red" text-color="white">{{ laravelErrors.message }}

</v-chip>

</div> -->

                        <v-text-field type="email" name="email" label="Email" prepend-icon="email" v-model="email" v-validate="'required|email'">
                        </v-text-field>
                        <div class="error--text text-xs-center">{{ errors.first('email') }}</div>

                    </v-card-text>
                    <v-card-actions class="px-5 pb-3" style="flex-wrap: wrap;">
                        <a @click="$router.push({name: 'Login'})">Return to Login</a>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="sendResetEmail" :loading="loading">Send Email</v-btn>
                    </v-card-actions>
                </v-card>
            </form>

            <v-card v-else>
                <v-toolbar dark :color="results.color">
                    <v-toolbar-title>{{ results.heading }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <p class="headline py-3">{{ results.body }}</p>
                </v-card-text>
                <v-card-actions class="px-3 pb-3" style="flex-wrap: wrap;">
                    <v-btn small color="error" v-if="results.tryagain" @click="results.active = false">Try again</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" @click="$router.push({name: 'Login'})">Return to login</v-btn>
                </v-card-actions>
            </v-card>

        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import axios from 'axios'
import throttle from 'lodash.throttle'

export default {
    data() {
        return {
            email: '',
            loading: false,
            results: {
                active: false,
                tryagain: false,
                color: '#000',
                heading: '',
                body: ''
            }
        }
    },
    methods: {
        sendResetEmail: throttle(function () {
            this.$validator.validate('email').then((result) => {
                this.loading = true
                if (result) {
                    axios.post('/api/password/email', {
                            'email': this.email
                        }).then((response) => {
                            this.loading = false
                            this.results = {
                                active: true,
                                tryagain: false,
                                color: '#23d160',
                                heading: 'Success',
                                body: 'Email was successfully sent, please check your inbox for instructions.'
                            }
                        })
                        .catch((e) => {
                            this.loading = false
                            this.results = {
                                active: true,
                                tryagain: true,
                                color: '#ff3860',
                                heading: 'Failure',
                                body: 'Opps, something went wrong. Please try again.'
                            }
                        })
                } else {
                    this.loading = false
                }
            })
        }, 2000)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.commit('clearErrors')
        })
    },
}
</script>
